module.exports = __webpack_public_path__ + "images/icon_fullscreen_out_5745a43b461a3cb94cc1cfa06444731e.svg";